// src/components/LoadingScreen.js
import React from 'react';
import '../../index.css'; // Optional: For custom styling

export const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <div className="loading-spinner"></div>
      <h2>Loading, please wait...</h2>
    </div>
  );
}
